import React, { useState } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client'
import './Footer.scss'; 

const Footer = () => {

  const [formData, setFormData] = useState({ name: '', email: '', message: ''});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // Destructuring 
  // => no need to formData.name etc ... 
  const { name, email, message } = formData; 

  const handleChangeInput = (e) => {
    // Destructuring 
    const { name, value } = e.target;

    // Destructure all of the current values in formData and Dynamically change the name with a corresponding specific value 
    setFormData({ ...formData, [name]: value});
  }

  const handleSubmit = () => {
    setLoading(true); 

    // Note : We have to follow the Sanity guidelines 
    const contact = {
      _type: 'contact',
      name: name,
      email: email, 
      message: message,
    }

    client.create(contact)
      .then(() => {
        // If successfully received data 
        setLoading(false);
        setIsFormSubmitted(true);
      })
  }

  return (
    <>
      <h2 className='head-text'> Come & Chat with me</h2>

      <div className='app__footer-cards'>

        <div className='app__footer-card'>
          <img src={images.email2} alt="email" />
          {/* lead you straight to the email given */}
          <a href="mailto:tanw0270@e.ntu.edu.sg" className='p-text'>tanw0270@e.ntu.edu.sg</a>
        </div>

        <div className='app__footer-card'>
          <img src={images.mobile} alt="mobile" />
          {/* lead you straight to my number */}
          <a href="tel: +65 9459 7256" className='p-text'>+65 9459 7256</a>
        </div>

      </div>

      {/* If the form is not submitted, show the app__footer-form, else display 'Thank you for ...' */}
      { !isFormSubmitted ? 
        <div className='app__footer-form app__flex'>

          <div className='app__flex'>
            <input className='p-text' type="text" placeholder="Your Name" name="name" value={name} onChange={handleChangeInput} />
          </div>

          <div className='app__flex'>
            <input className='p-text' type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>

          <div className='app__flex'>
            <textarea 
              className='p-text'
              placeholder='Your Message'
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>

          {/* If the state is loading, then 'sending' will appeat else 'Send Message will appear' */}
          <button type="button" className='p-text' onClick={handleSubmit}>{loading ? 'Sending' : 'Send Message'}</button>

        </div>
        : 
        <div>
          <h3 className='head-text'>Thank you for getting in touch</h3>
        </div>
      }
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg'
  )